import { RETAIL_HEADER_KEY } from './config'

export const retaiCategoryHeadersTranslation = {
  row1: {
    code: `${RETAIL_HEADER_KEY}-row1-code`,
    subCat: `${RETAIL_HEADER_KEY}-row1-subcat`,

    tamGrowth: `${RETAIL_HEADER_KEY}-row1-tam-yoy`, // FY {cy} RETAILER TAM GROWTH

    finActualsPy: `${RETAIL_HEADER_KEY}-row1-fin-actuals`, // HP FY {py} {netNdp} SALES $
    finGoalCy: `${RETAIL_HEADER_KEY}-row1-fin-goal`, // HP FY {cy} {netNdp} SALES $
    finYoY: `${RETAIL_HEADER_KEY}-row1-fin-yoy`, // {py} vs {cy} {netNdp} SALES $
    finActualsCy: `${RETAIL_HEADER_KEY}-row1-fin-actuals-cy`, // HP FY {cy} {netNdp} SALES ACTUALS $
    finActualsYoY: `${RETAIL_HEADER_KEY}-row1-fin-actuals-yoy`, // {py} vs {cy} {netNdp} SALES ACTUALS (% Y/Y)

    sobActualsPy: `${RETAIL_HEADER_KEY}-row1-sob-actuals`, // FY {py} $ SOB
    sobGoalCy: `${RETAIL_HEADER_KEY}-row1-sob-goal`, // FY {cy} $ SOB
    sobYoY: `${RETAIL_HEADER_KEY}-row1-sob-yoy`, // {py} vs {cy} SOB
    sobActualsCy: `${RETAIL_HEADER_KEY}-row1-sob-actuals-cy`, // FY {cy} $ SOB ACTUALS
    sobActualsYoY: `${RETAIL_HEADER_KEY}-row1-sob-actuals-yoy`, // {py} vs {cy} SOB ACTUALS (P.P. Y/Y)
  },

  row2: {
    code: `${RETAIL_HEADER_KEY}-row2-code`,
    subCat: `${RETAIL_HEADER_KEY}-row2-subcat`,

    tamGrowth: `${RETAIL_HEADER_KEY}-row2-tam-yoy`, // FY {cy} RETAILER TAM GROWTH

    finActualsPy: `${RETAIL_HEADER_KEY}-row2-fin-actuals`, // HP FY {py} {netNdp} SALES $
    finGoalCy: `${RETAIL_HEADER_KEY}-row2-fin-goal`, // HP FY {cy} {netNdp} SALES $
    finYoY: `${RETAIL_HEADER_KEY}-row2-fin-yoy`, // {py} vs {cy} {netNdp} SALES $
    finActualsCy: `${RETAIL_HEADER_KEY}-row2-fin-actuals-cy`, // HP FY {cy} {netNdp} SALES ACTUALS $
    finActualsYoY: `${RETAIL_HEADER_KEY}-row2-fin-actuals-yoy`, // {py} vs {cy} {netNdp} SALES ACTUALS (% Y/Y)

    sobActualsPy: `${RETAIL_HEADER_KEY}-row2-sob-actuals`, // FY {py} $ SOB
    sobGoalCy: `${RETAIL_HEADER_KEY}-row2-sob-goal`, // FY {cy} $ SOB
    sobYoY: `${RETAIL_HEADER_KEY}-row2-sob-yoy`, // {py} vs {cy} SOB
    sobActualsCy: `${RETAIL_HEADER_KEY}-row2-sob-actuals-cy`, // FY {cy} $ SOB ACTUALS
    sobActualsYoY: `${RETAIL_HEADER_KEY}-row2-sob-actuals-yoy`, // {py} vs {cy} SOB ACTUALS (P.P. Y/Y)
  },
}

export default retaiCategoryHeadersTranslation
